import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface AuditLogState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAuditLogs: any[];
}

const initialState: AuditLogState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allAuditLogs: [],
};

export const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    setAuditLogs: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAuditLogsBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAuditLogs: (state, action) => {
      state.allAuditLogs = action.payload.data;
    },
    resetAuditLog: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setAuditLogs,
  setAuditLogsBySearch,
  setAllAuditLogs,
  resetAuditLog,
} = auditLogSlice.actions;

export const getAuditLogData = (state: RootState) => state.auditLog.data;
export const getAuditLogDataBySearch = (state: RootState) => state.auditLog.data;
export const getAllAuditLogList = (state: RootState) => state.auditLog.allAuditLogs;
export const getAuditLogTotalRecords = (state: RootState) => state.auditLog.totalRecords;

export default auditLogSlice.reducer;
